import Module from '../utils/Module';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export default class InternalNavModule extends Module {
  constructor(options) {
    super(options)

    this.DOMEl = this.options.element;
    this.navInner = this.DOMEl.querySelector(".nav-intern-module__inner");
    this.links = this.navInner.querySelectorAll("a")
    this.sections = document.querySelectorAll("[data-section-id]");
    this.navTitle = this.DOMEl.querySelector(".title__text");
    this.navTitle.innerHTML = this.links[0].getAttribute("data-section-name");

    this.mouse = false;

    this.init();
  }

  init() {

    this.navInner.addEventListener('mouseenter', () => {
      this.mouseStatus(true);
      this.onOpenDropdown();
    });
    this.navInner.addEventListener('mouseleave', () => {
      this.mouseStatus(false);
      this.onCloseDropdown();
    });

    document.addEventListener('scroll', () => {
      if (window.scrollY==0) {
        this.onOpenDropdown();
      } else {
        this.onCloseDropdown();
      }
    });

    this.navInner.addEventListener('touchstart', this.onOpenDropdown.bind(this));
    this.navInner.addEventListener('touchmove', this.onCloseDropdown.bind(this));

    this.navInner.addEventListener('focus', this.onOpenDropdown.bind(this));
    this.links.forEach(link => {
      link.addEventListener('blur', this.onCloseDropdown.bind(this));
    });
    this.links[this.links.length - 1].addEventListener('blur', this.onCloseDropdown.bind(this));
    this.links.forEach(link => {
      link.addEventListener('click', this.trackClick.bind(this));
    });

    this.sections.forEach(section => {
      ScrollTrigger.create({
        trigger: section,
        start: "top center",
        end: "center+=0 center",
        scrub: true,
        onEnter: () => {
          this.enter(section)
        },
        onLeave: () => {
          this.leave(section)
        },
        onEnterBack: () => {
          this.enter(section)
        },
        onLeaveBack: () => {
          this.leave(section)
        }
      });
    });
  }

  enter(section) {
    const sectionAttributeId = section.getAttribute("data-section-id");
    const concordingLink = this.navInner.querySelector(`a[data-nav-id="#${sectionAttributeId}"]`);
    if(concordingLink !== null)
    {
      concordingLink.classList.add('nav-intern-module__link--current');

      this.navTitle.innerHTML = concordingLink.getAttribute("data-section-name")
    }
  }

  leave(section) {
    const sectionAttributeId = section.getAttribute("data-section-id")
    const concordingLink = this.navInner.querySelector(`a[data-nav-id="#${sectionAttributeId}"]`);
    if(concordingLink !== null)
    {
      concordingLink.classList.remove('nav-intern-module__link--current');
    }
  }

  onOpenDropdown() {
    //e.stopPropagation()
    this.navInner.classList.add("nav-intern-module__inner--expanded");
  }

  onCloseDropdown() {
    if (!this.mouse || window.innerWidth <= 1024) {
      this.navInner.classList.remove("nav-intern-module__inner--expanded");
    }
  }

  mouseStatus(p) {
    this.mouse = p;
  }

  trackClick(e) {
    dataLayer.push({
      "event": "contentInteraction",
      "interaction": {
        "category": "anchor interaction",
        "action": e.target.textContent,
        "label": window.location.href
      }
    });
  }
}
